export function sanitizeAbcBody(abc) {
  return abc
    .split('\n')
    .map(line => line.trim())
.filter(line => {
  if (line === '') return false;
  if (/^X:/.test(line)) return false; // remove X
  return true; // allow all other lines
})
    .map(line => {
      if (/^[A-Z]:/.test(line)) return line;
      return line
        .replace(/\|\|\s*\|\|/g, '||')
        .replace(/:\|\s*\|\|/g, ':|')
        .replace(/(^|[^!])!($|[^!])/g, '$1$2') // remove standalone ! linebreaks
        .replace(/\s+/g, ' ')
        .replace(/^\s+|\s+$/g, '');
    })
    .join('\n');
}
